import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { JobState } from './states'

const Job: Module<JobState, State> = {
  state: new JobState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default Job
